import { api } from "@/lib/api-client";
import type { Paginated } from "../agents/api";

export type Flow = {
  id: string;
  name: string;
  description?: string;
  status: "draft" | "published" | "archived" | string;
  version: number;
  is_valid: boolean;
  validation_errors?: string[];
  nodes?: unknown[];
  edges?: unknown[];
  created_at?: string;
  updated_at: string;
};

export type AvailableFunction = {
  name: string;
  description: string;
  source: string;
};

export const flowsApi = {
  list: async () => {
    const res = await api.get<Paginated<Flow> | Flow[]>("/agents/flows/");
    return Array.isArray(res.data) ? res.data : res.data.results;
  },

  get: async (id: string) => {
    const res = await api.get<Flow>(`/agents/flows/${id}/`);
    return res.data;
  },

  create: async (data: { name: string; description?: string }) => {
    const res = await api.post<Flow>("/agents/flows/", data);
    return res.data;
  },

  update: async (id: string, data: Partial<Flow>) => {
    const res = await api.patch<Flow>(`/agents/flows/${id}/`, data);
    return res.data;
  },

  remove: async (id: string) => {
    await api.delete(`/agents/flows/${id}/`);
  },

  validate: async (id: string) => {
    const res = await api.post<{ is_valid: boolean; errors: string[] }>(
      `/agents/flows/${id}/validate/`,
    );
    return res.data;
  },

  publish: async (id: string) => {
    const res = await api.post<Flow>(`/agents/flows/${id}/publish/`);
    return res.data;
  },

  availableFunctions: async () => {
    const res = await api.get<AvailableFunction[]>(
      "/integrations/available-functions/",
    );
    return res.data;
  },
};
